import * as t from 'ts-schema';
import { registerQuery } from 'data-fetching-client';
import { getApiClient } from '../../clients/apiClient';
import { getQuickFetch } from '../../clients/ecosystemClient';
import * as AppContext from '../../constants/AppContext';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
export const moduleCategoriesResponseSchema = t.object({
  results: t.array(t.object({
    id: t.number,
    name: t.string,
    displayName: t.string
  }))
});
export const GET_MODULE_CATEGORIES_QUERY = registerQuery({
  fieldName: 'moduleCategories',
  args: ['lang', 'appContext'],
  fetcher: ({
    lang,
    appContext
  }) => {
    return getQuickFetch('module-categories').catch(() => {
      // SOX Compliance special handling for Admin Preview
      if (appContext === AppContext.ADMIN_PREVIEW) {
        return noAuthApiClient.get('content/categories/v1/categories/meta/no-auth', {
          query: {
            lang
          }
        });
      }
      return getApiClient().get(appContext === AppContext.PUBLIC ? 'content/categories/v1/categories/meta/no-auth' : 'content/categories/v1/categories/meta', {
        query: {
          lang
        }
      });
    });
  }
});